import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from '../ui/Button';
import { locations } from '../../data/locations';
interface LocationContactFormProps {
  preselectedLocationId: string;
}
export function LocationContactForm({
  preselectedLocationId
}: LocationContactFormProps) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    location: preselectedLocationId,
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact-form" className="py-16 bg-white" data-id="element-454">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
        <div className="text-center mb-12" data-id="element-456">
          <div className="inline-flex items-center justify-center p-3 bg-slate-100 rounded-full mb-4" data-id="element-457">
            <Mail className="h-6 w-6 text-[#dc2626]" data-id="element-458" />
          </div>
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-459">
            Contact This Location
          </h2>
          <p className="text-slate-600" data-id="element-460">
            Have questions? Fill out the form below and we'll get back to you as
            soon as possible.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-50 rounded-xl border border-slate-200 p-8" data-id="element-461">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-462">
            <div data-id="element-463">
              <label htmlFor="firstName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-464">
                First Name *
              </label>
              <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-465" />
            </div>

            <div data-id="element-466">
              <label htmlFor="lastName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-467">
                Last Name *
              </label>
              <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-468" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-469">
            <div data-id="element-470">
              <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-471">
                Phone Number *
              </label>
              <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-472" />
            </div>

            <div data-id="element-473">
              <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-474">
                Email *
              </label>
              <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-475" />
            </div>
          </div>

          <div className="mb-6" data-id="element-476">
            <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-477">
              Preferred Location *
            </label>
            <select id="location" name="location" required value={formData.location} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-478">
              {locations.map(location => <option key={location.id} value={location.id} data-id="element-479">
                  {location.name}
                </option>)}
            </select>
          </div>

          <div className="mb-6" data-id="element-480">
            <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-481">
              Message (Optional)
            </label>
            <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="Tell us about your goals or ask any questions..." data-id="element-482" />
          </div>

          <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-483">
            Send Message
          </Button>
        </form>
      </div>
    </section>;
}